import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Avatar,
} from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface AblehnungsgrundCardProps {
  ablehnungsgrund: string;
}

const AblehnungsgrundCard: React.FC<AblehnungsgrundCardProps> = ({ ablehnungsgrund }) => {
  // Semikolon-getrennte Fehlermeldungen aufsplitten
  const fehlermeldungen = ablehnungsgrund
    .split(';')
    .map(msg => msg.trim())
    .filter(msg => msg.length > 0);

  return (
    <Card 
      elevation={3} 
      sx={{ 
        mb: 2, 
        border: '2px solid',
        borderColor: 'error.main',
        backgroundColor: 'error.light',
        '& .MuiCardHeader-root': {
          backgroundColor: 'error.main',
          color: 'error.contrastText',
        }
      }}
    >
      <CardHeader
        avatar={
          <Avatar sx={{ bgcolor: 'error.dark' }}>
            <ErrorIcon />
          </Avatar>
        }
        title="Antrag abgelehnt"
        subheader={
          <Typography variant="body2" sx={{ color: 'error.contrastText', opacity: 0.9 }}>
            Der Antrag wurde vom KBA mit folgenden Fehlermeldungen abgelehnt:
          </Typography>
        }
      />
      <CardContent sx={{ backgroundColor: 'background.paper' }}>
        <List dense disablePadding>
          {fehlermeldungen.map((meldung, index) => (
            <ListItem key={index} sx={{ py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36 }}>
                <WarningAmberIcon color="error" fontSize="small" />
              </ListItemIcon>
              <ListItemText 
                primary={meldung}
                primaryTypographyProps={{
                  variant: 'body2',
                  color: 'text.primary'
                }}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default AblehnungsgrundCard;
